// extracted by mini-css-extract-plugin
export var active = "pill-switcher-module--active--711cb";
export var badge = "pill-switcher-module--badge--5b1a7";
export var button = "pill-switcher-module--button--87e35";
export var pillContainer = "pill-switcher-module--pill-container--1e311";
export var pillInnerContainer = "pill-switcher-module--pill-inner-container--878f1";
export var pillOuterContainer = "pill-switcher-module--pill-outer-container--0ddf7";
export var pillSwitcher = "pill-switcher-module--pill-switcher--d9ca9";
export var slider = "pill-switcher-module--slider--3df97";
export var small = "pill-switcher-module--small--2d4c9";
export var title = "pill-switcher-module--title--467d9";
export var withBadges = "pill-switcher-module--with-badges--42ba6";